export const customStyles = {
  //any type, lack of documentation
  control: (provided: any) => ({
    ...provided,
    background: 'transparent',
    display: 'flex',
    cursor: 'pointer',
    boxShadow: 'none !important',
    flexWrap: 'nowrap',
    border: 'none',
    borderBottom: 'rgba(223, 218, 240, 0.9) 1px solid',
    borderRadius: 'none',
    width: '100%',

    '&:hover': {
      borderBottom: 'rgba(97, 76, 180, 1) 1px solid',
    },
  }),
  //any type, lack of documentation
  menu: (provided: any) => ({
    ...provided,
    width: '100%',
  }),
}
